import styled from 'styled-components';
import { HeadingExtraBoldS } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';

export const ResourcesTableTileCont = styled.div`
  display: flex;
  justify-content: space-between;
  height: 64px;
  align-items: center;
  border-radius: 8px;

  ${({theme}: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.centy} 0;
    padding: 0 ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.mega};
    background: ${theme.colors.neutral.primary[0]};
    box-shadow: 0 1px 1px ${theme.colors.neutral.primary[30]};

    &:hover {
      background: ${theme.colors.primary[10]};
    }
  `};
`;

export const ResourceTitle = styled(HeadingExtraBoldS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]}
  `}
`;

export const DownloadIconCont = styled.a`
   display: flex;
   width: 48px;
   height: 48px;
   justify-content: center;
   align-items: center;
   cursor: pointer;
`;
